import FactoryIcon from "@mui/icons-material/Factory";
import HealingIcon from "@mui/icons-material/Healing";
import HomeIcon from "@mui/icons-material/Home";
import MonitorHeartIcon from "@mui/icons-material/MonitorHeart";
import React from "react";
import SellIcon from "@mui/icons-material/Sell";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import { ICSDrawerContents } from "@ntg/component-library/declarations";

export function getDrawerContents(
    activeCount: number,
    isGlobalAdmin: boolean,
): ICSDrawerContents {
    return {
        Items: [
            {
                DrawerItems: [
                    {
                        Icon: <HomeIcon color="secondary" />,
                        PrimaryText: "Home",
                        ShowMobile: true,
                        To: "/home",
                    },
                ],
                ShowTitle: false,
                Title: "",
            },
            {
                DrawerItems: [
                    {
                        Icon: <SellIcon color="secondary" />,
                        PrimaryText: "Sales Order Search",
                        ShowMobile: true,
                        To: "/salesorder",
                    },
                ],
                ShowTitle: true,
                Title: "SALES",
            },
            {
                DrawerItems: [
                    {
                        Icon: <HealingIcon color="secondary" />,
                        PrimaryText: "Service Order Search",
                        ShowMobile: true,
                        To: "/serviceorder",
                    },
                ],
                ShowTitle: true,
                Title: "SERVICE",
            },
            {
                DrawerItems: [
                    {
                        Icon: <FactoryIcon color="secondary" />,
                        PrimaryText: "Manufacturing Search",
                        ShowMobile: true,
                        To: "/manufacturing",
                    },
                ],
                ShowTitle: true,
                Title: "MANUFACTURING",
            },
            // Process Monitor is restricted to Global Admins.
            ...(isGlobalAdmin
                ? [
                      {
                          DrawerItems: [
                              {
                                  BadgeValue:
                                      activeCount > 0 ? activeCount : undefined,
                                  Icon: <MonitorHeartIcon color="secondary" />,
                                  PrimaryText: "Process Monitor",
                                  ShowMobile: true,
                                  To: "/monitor",
                              },
                          ],
                          ShowTitle: true,
                          Title: "MONITORING",
                      },
                  ]
                : []),
            // OData Explorer is restricted to Global Admins.
            ...(isGlobalAdmin
                ? [
                      {
                          DrawerItems: [
                              {
                                  Icon: <TravelExploreIcon color="secondary" />,
                                  PrimaryText: "OData Explorer",
                                  ShowMobile: true,
                                  To: "/odata-explorer",
                              },
                          ],
                          ShowTitle: true,
                          Title: "TOOLS",
                      },
                  ]
                : []),
        ],
    };
}